import React, { Fragment, useMemo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { cellStyles } from './HeaderGrid.styles';
import { getCellRowSpan } from './HeaderGrid.utils';

const HeaderGridCell = ({ cell, renderItem, getItemKey }) => {
  const cellRowSpan = getCellRowSpan(cell);
  const rowIndex = cell.rowIndex ?? 0;

  const cellSx = useMemo(
    () => ({ ...cellStyles, gridRow: `${rowIndex + 1} / span ${cellRowSpan}` }),
    [rowIndex, cellRowSpan],
  );

  return (
    <Box sx={cellSx}>
      {cell.items.map(item => (
        <Fragment key={getItemKey(item)}>{renderItem(item)}</Fragment>
      ))}
    </Box>
  );
};

HeaderGridCell.propTypes = {
  cell: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
    items: PropTypes.array.isRequired,
  }).isRequired,
  getItemKey: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
};

export default HeaderGridCell;
